import React, { useContext, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import { PAGES, PROFESSIONAL_ROLES, getProfessionalCategory } from './utils/constants'

import Professionals from './Routes/Professionals'
import Vets from './Routes/Vets'

import Login from './pages/Default/Login'
import ForgotPasswordView from './pages/Default/ForgotPasswordView'
import CreatePasswordView from './pages/Default/CreatePasswordView'
import ScrollToTop from './components/ScrollToTop'

import { RootContext } from './context/rootContext'

import Footer from './components/Footer'

const Routes = () => {
  const { globalState } = useContext(RootContext)
  const [state] = globalState
  const { userData } = state
  const isVet = userData?.professional?.role === PROFESSIONAL_ROLES.VETERINARIAN
  const forgotPasswordURL = `${PAGES.FORGOT_PASSWORD_URL}/:professionalId`
  const createPasswordURL = `${PAGES.CREATE_PASSWORD_URL}`
  const pathname = window.location.pathname

  const isFreelance = getProfessionalCategory() === 'FREELANCE'
  const isFranchising = getProfessionalCategory() === 'FRANCHISING'
  const hasMainProfessionalFranchising = userData?.professional?.mainProfessional?.category === 'FRANCHISING'
  let authVet
  if (isFreelance) {
    authVet = isVet && hasMainProfessionalFranchising
  } else {
    authVet = isVet && isFranchising
  }

  useEffect(() => {
    if (authVet && pathname === '/') {
      return (window.location.href = '/vets')
    }
  }, [authVet, pathname])

  return (
    <Router basename={process.env.REACT_APP_BASEPATH}>
      <Switch>
        <Route path='/login'>
          <ScrollToTop />
          <Login />
        </Route>,
        <Route path={forgotPasswordURL}>
          <ScrollToTop />
          <ForgotPasswordView />
        </Route>,
        <Route path={createPasswordURL}>
          <ScrollToTop />
          <CreatePasswordView />
          <Footer />
        </Route>
        {authVet
          ? <Route path="/" render={(props) => <Vets {...props} />} />
          : <Route path="/" render={(props) => <Professionals {...props} isVet={authVet} isFreelance={isFreelance} />} />}
      </Switch>
    </Router>
  )
}

export default Routes
